import React, { Component } from 'react';
import './App.css';
import FormInput from './FormInput';

class ContactForm extends Component {
  constructor(){
    super()
    this.state = {
      span: false
    }
  }
  componentWillMount(){
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  render(){
    var t = this, s = this.state;
    var classUp =  s.span === true ? "upped" : "downed";
    //console.log(classUp);
    return (
      <div style={{width: '100%', backgroundColor: '#363636b8'}} >
        <div className="template-content" style={{textAlign: 'center', marginTop: '100px'}}>
          <FormInput />
        </div>
      </div>
    );
  }
}



var styling = {
  diagonalBackgroundHeader: {
    backgroundAttachment: 'fixed',
    transform: 'skewY(6.5deg)',
    margin: '-12% 0px',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundSize: 'cover'
  }
};



export default ContactForm;



// WEBPACK FOOTER //
// ./src/ContactForm.js